import { createContext } from 'react';
import type { UseCreatePersonaFormReturn } from '../hooks/useCreatePersonaForm';

export const FormContext = createContext<UseCreatePersonaFormReturn | null>(null);
